(function () {
  'use strict';

  var root = document.querySelector('[data-smart-planner]');
  if (!root) return;

  if (window.location.pathname === '/pages/smart-planner-ar') {
    window.location.replace('/pages/smart-planner' + window.location.search + window.location.hash);
    return;
  }

  var MAX_QTY = 10;
  var RECOMMENDED = [
    { id: 'table-lamp', handle: 'table-lamp', title: 'Table Lamp' },
    { id: 'floor-lamp', handle: 'floor-lamp', title: 'Floor Lamp' },
    { id: 'coffee-tables', handle: 'coffee-tables', title: 'Coffee Table' },
    { id: 'end-tables', handle: 'end-tables', title: 'Side Table' },
    { id: 'bedding', handle: 'bedding', title: 'Bedding' },
    { id: 'pillows', handle: 'pillow', title: 'Pillows' },
    { id: 'vases', handle: 'vases', title: 'Vases' },
    { id: 'frames', handle: 'frames', title: 'Frames' },
    { id: 'coffee-corner', handle: 'nesting-tables', title: 'Coffee Corner' },
    { id: 'shoe-racks', handle: 'cover-shoes', title: 'Shoe Rack' }
  ];

  var state = {
    step: 1,
    home: null,
    categories: [],
    budget: 1000,
    items: [],
    groups: [],
    recommended: [],
    mattressSize: null,
    changeCursor: {},
    recommendationCursor: {}
  };

  var STORAGE_KEY = 'mksp_planner_state_v3_ar';
  var restoringState = false;

  var isArabic = true;
  var labels = {
    en: {
      step: 'Step {step} of 4',
      titles: ['Choose Your Home', 'Select Furniture Categories', 'Budget', 'Your Package'],
      chooseHome: 'Please choose your home type.',
      chooseCategory: 'Please choose at least one category.',
      lock: 'Lock',
      locked: 'Locked',
      change: 'Change',
      remove: 'Remove',
      viewProduct: 'View Product',
      selectedPackage: 'Your Selected Package',
      savePackage: 'Save Package',
      noProducts: 'No available products found',
      checkProducts: 'Please check that the selected collections contain available products.',
      closest: 'Closest package found',
      bestMatch: 'The selected products are the best match available inside your selected budget.',
      recommended: 'Recommended Add-ons',
      recommendedDesc: 'Small finishing pieces you can add to complete the package.',
      addFor: 'Add this for +',
      addWithin: 'Add within remaining budget',
      product: 'Product',
      products: 'Products',
      lowBudget: 'The selected budget is too low for these choices. Minimum recommended budget is ',
      collectionMissing: 'Some selected categories do not have available products right now. Please review the selected categories or collection availability.',
      lockedChange: 'This product is locked. Unlock it before changing.',
      lockedRemove: 'This product is locked. Unlock it before removing.',
      noAlternative: 'No alternative product is available within the selected budget.',
      recLockedChange: 'This recommendation is locked. Unlock it before changing.',
      recLockedRemove: 'This recommendation is locked. Unlock it before removing.',
      noRecAlternative: 'No alternative recommendation is available right now.',
      saved: 'Package saved in this browser.',
      saveFailed: 'Could not save this package.',
      noCart: 'No products are available to add.',
      adding: 'Adding...',
      cartFailed: 'Could not add the package to cart.',
      categoryTitles: {}
    },
    ar: {
      step: 'الخطوة {step} من 4',
      titles: ['اختر نوع السكن', 'اختر فئات الأثاث', 'الميزانية', 'باقتك'],
      chooseHome: 'من فضلك اختر نوع السكن.',
      chooseCategory: 'من فضلك اختر فئة واحدة على الأقل.',
      lock: 'تثبيت',
      locked: 'مثبت',
      change: 'تبديل',
      remove: 'حذف',
      viewProduct: 'عرض المنتج',
      selectedPackage: 'الباقة المختارة',
      savePackage: 'حفظ الباقة',
      noProducts: 'لا توجد منتجات متاحة',
      checkProducts: 'تأكد أن الكولكشن المختارة تحتوي على منتجات متاحة.',
      closest: 'أفضل باقة متاحة',
      bestMatch: 'تم اختيار أقرب منتجات مناسبة داخل الميزانية المحددة.',
      recommended: 'منتجات مقترحة',
      recommendedDesc: 'قطع إضافية خفيفة لإكمال الباقة.',
      addFor: 'أضف المنتج مقابل +',
      addWithin: 'أضف ضمن الميزانية المتبقية',
      product: 'منتج',
      products: 'منتجات',
      lowBudget: 'الميزانية المختارة قليلة لهذه الاختيارات. أقل ميزانية مقترحة هي ',
      collectionMissing: 'بعض الفئات المختارة لا تحتوي على منتجات متاحة الآن. برجاء مراجعة الاختيارات أو توفر المنتجات.',
      lockedChange: 'هذا المنتج مثبت. قم بإلغاء التثبيت قبل التبديل.',
      lockedRemove: 'هذا المنتج مثبت. قم بإلغاء التثبيت قبل الحذف.',
      noAlternative: 'لا يوجد بديل متاح داخل الميزانية المختارة.',
      recLockedChange: 'هذا الاقتراح مثبت. قم بإلغاء التثبيت قبل التبديل.',
      recLockedRemove: 'هذا الاقتراح مثبت. قم بإلغاء التثبيت قبل الحذف.',
      noRecAlternative: 'لا يوجد اقتراح بديل متاح الآن.',
      saved: 'تم حفظ الباقة في هذا المتصفح.',
      saveFailed: 'تعذر حفظ الباقة.',
      noCart: 'لا توجد منتجات متاحة للإضافة.',
      adding: 'جاري الإضافة...',
      cartFailed: 'تعذر إضافة الباقة إلى السلة.',
      categoryTitles: {
        'bedroom-without-wardrobe': 'غرفة نوم بدون دولاب',
        'bedroom-with-wardrobe': 'غرفة نوم مع دولاب',
        wardrobe: 'دولاب',
        beds: 'سرير',
        'bedroom-pieces': 'قطع غرف نوم',
        mattresses: 'مراتب',
        bedding: 'مفارش',
        pillows: 'مخدات',
        'sofa-set': 'طقم كنب',
        'corner-sofa-sets': 'كنب زاوية',
        'sofa-bed': 'كنبة سرير',
        'three-seater': 'كنبة 3 مقاعد',
        'two-seater-sofa': 'كنبة مقعدين',
        'single-seaters': 'كرسي مفرد',
        'dining-sets': 'طاولة سفرة وكراسي',
        'dining-buffet-storage': 'بوفيه وتخزين سفرة',
        'dining-chairs': 'كراسي سفرة',
        'full-dining-room': 'غرفة سفرة كاملة',
        'coffee-tables': 'طاولة وسط',
        'end-tables': 'طاولة جانبية',
        'tv-units': 'وحدة تلفزيون',
        'shoe-racks': 'جزامة',
        'coffee-corner': 'ركن قهوة',
        'kids-teens': 'أطفال وشباب',
        'outdoor-furniture': 'أثاث خارجي',
        'crystal-chandelier': 'ثريا كريستال',
        'led-chandelier': 'ثريا LED',
        'floor-lamp': 'أباجورة أرضية',
        'table-lamp': 'أباجورة طاولة',
        vases: 'فازات',
        frames: 'براويز'
      }
    }
  };

  function t(key) {
    return (isArabic ? labels.ar : labels.en)[key] || labels.en[key] || key;
  }

  function applyArabicStaticText() {
    if (!isArabic) return;

    root.classList.add('mksp--rtl');
    root.setAttribute('dir', 'rtl');

    var heroEyebrow = root.querySelector('.mksp-hero .mksp-eyebrow');
    var heroTitle = root.querySelector('.mksp-hero h1');
    var heroText = root.querySelector('.mksp-hero p:not(.mksp-eyebrow)');
    var startButton = root.querySelector('[data-start-planner]');

    if (heroEyebrow) heroEyebrow.textContent = 'مخطط الأثاث الذكي';
    if (heroTitle) heroTitle.textContent = 'أثث منزلك';
    if (heroText) heroText.textContent = 'أنشئ باقة الأثاث المناسبة لمنزلك.';
    if (startButton) startButton.textContent = 'ابدأ التخطيط';

    var stepHeads = {
      1: ['الخطوة 1', 'اختر نوع السكن', 'اختر نوع المنزل الذي تريد تأثيثه.'],
      2: ['الخطوة 2', 'اختر فئات الأثاث', 'افتح كل قسم واختر القطع التي تحتاجها.'],
      3: ['الخطوة 3', 'الميزانية', 'حدد الميزانية المناسبة للباقة.']
    };

    Object.keys(stepHeads).forEach(function (step) {
      var head = root.querySelector('[data-step="' + step + '"] .mksp-head');
      if (!head) return;
      var p = head.querySelector('p');
      var h2 = head.querySelector('h2');
      var span = head.querySelector('span');
      if (p) p.textContent = stepHeads[step][0];
      if (h2) h2.textContent = stepHeads[step][1];
      if (span) span.textContent = stepHeads[step][2];
    });

    var homes = {
      studio: ['استوديو', 'باقة مناسبة للمساحات المفتوحة الصغيرة.'],
      '1-bedroom-apartment': ['غرفة وصالة', 'باقة غرفة نوم وصالة مع أساسيات السفرة.'],
      '2-bedroom-apartment': ['غرفتين وصالة', 'اختيارات متوازنة لشقة عائلية عملية.'],
      '3-bedroom-apartment': ['3 غرف وصالة', 'باقة أوسع لتجهيز منزل متكامل.'],
      villa: ['فيلا', 'خطة تأثيث كاملة للمساحات الواسعة.']
    };

    Object.keys(homes).forEach(function (key) {
      var button = root.querySelector('[data-home="' + key + '"]');
      if (!button) return;
      var title = button.querySelector('b');
      var desc = button.querySelector('span');
      if (title) title.textContent = homes[key][0];
      if (desc) desc.textContent = homes[key][1];
    });

    var summaries = {
      Bedrooms: 'غرف النوم',
      'Mattresses & Bedding': 'المراتب والمفارش',
      Sofas: 'الكنب',
      'Dining Rooms': 'غرف السفرة',
      'Living Rooms': 'غرف المعيشة',
      Kids: 'الأطفال',
      Outdoor: 'الأثاث الخارجي',
      Lighting: 'الإضاءة',
      Decor: 'الديكور'
    };

    root.querySelectorAll('.mksp-accordion summary').forEach(function (summary) {
      var text = summary.textContent.trim();
      if (summaries[text]) summary.textContent = summaries[text];
    });

    root.querySelectorAll('[data-next-step]').forEach(function (button) {
      button.textContent = 'التالي';
    });
    root.querySelectorAll('[data-prev-step]').forEach(function (button) {
      button.textContent = 'رجوع';
    });

    var generate = root.querySelector('[data-generate-package]');
    var add = root.querySelector('[data-add-package]');
    if (generate) generate.textContent = 'صمم الباقة';
    if (add) add.textContent = 'أضف الباقة إلى السلة';

    var loading = root.querySelector('[data-loading-state] h2');
    if (loading) loading.textContent = 'جاري بناء باقة الأثاث الخاصة بك...';

    var resultsHead = root.querySelector('[data-step="4"] .mksp-head');
    if (resultsHead) {
      var rp = resultsHead.querySelector('p');
      var rh = resultsHead.querySelector('h2');
      if (rp) rp.textContent = 'الخطوة 4';
      if (rh) rh.textContent = 'باقتك جاهزة';
    }

    var summaryLabels = root.querySelectorAll('.mksp-summary span');
    if (summaryLabels[0]) summaryLabels[0].textContent = 'المنتجات المختارة';
    if (summaryLabels[1]) summaryLabels[1].textContent = 'إجمالي الباقة';
    if (summaryLabels[2]) summaryLabels[2].textContent = 'المتبقي من الميزانية';
  }

  function routeRoot() {
    return '/ar/';
  }

  var titles = {
    1: t('titles')[0],
    2: t('titles')[1],
    3: t('titles')[2],
    4: t('titles')[3]
  };

  var cache = {};

  function $(selector) {
    return root.querySelector(selector);
  }

  function $$(selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function money(value) {
    return Math.round(Number(value) || 0).toLocaleString('en-US') + ' AED';
  }

  function esc(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[char];
    });
  }

  function clearAlert() {
    var el = $('[data-alert]');
    if (!el) return;
    clearTimeout(alertMsg.timer);
    el.hidden = true;
    el.classList.remove('mksp-alert--warning');
    el.innerHTML = '';
  }

  function alertMsg(message, keepVisible, warning) {
    var el = $('[data-alert]');
    if (!el) return;

    el.classList.toggle('mksp-alert--warning', !!warning);
    el.innerHTML = warning ? '<span aria-hidden="true"></span><b>' + esc(message) + '</b>' : esc(message);
    el.hidden = false;
    clearTimeout(alertMsg.timer);

    if (!keepVisible) {
      alertMsg.timer = setTimeout(clearAlert, 4200);
    }
  }

  function setStep(step) {
    state.step = step;
    clearAlert();

    $$('[data-step]').forEach(function (panel) {
      panel.classList.toggle('is-active', Number(panel.dataset.step) === step);
    });

    var label = $('[data-step-label]');
    var title = $('[data-step-title]');
    var fill = $('[data-progress-fill]');

    if (label) label.textContent = t('step').replace('{step}', step);
    if (title) title.textContent = titles[step];
    if (fill) fill.style.width = step * 25 + '%';

    var wizard = $('#smart-planner-wizard');
    if (wizard) wizard.scrollIntoView({ behavior: 'smooth', block: 'start' });
    persistPlannerState();
  }

  function persistPlannerState() {
    if (restoringState) return;
    if (!state.home && !state.categories.length && !state.items.length) return;

    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        step: state.step,
        home: state.home,
        categories: state.categories,
        budget: state.budget,
        items: state.items,
        groups: state.groups,
        recommended: state.recommended,
        mattressSize: state.mattressSize,
        changeCursor: state.changeCursor,
        recommendationCursor: state.recommendationCursor
      }));
    } catch (error) {
      // Browsers may block storage; the planner still works without persistence.
    }
  }

  function restorePlannerState() {
    var saved;

    try {
      saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
    } catch (error) {
      saved = null;
    }

    if (!saved || !saved.home) return false;

    restoringState = true;

    state.home = saved.home;
    state.categories = Array.isArray(saved.categories) ? saved.categories : [];
    state.budget = Number(saved.budget) || 1000;
    state.items = Array.isArray(saved.items) ? saved.items : [];
    state.groups = Array.isArray(saved.groups) ? saved.groups : [];
    state.recommended = Array.isArray(saved.recommended) ? saved.recommended : [];
    state.mattressSize = saved.mattressSize || null;
    state.changeCursor = saved.changeCursor || {};
    state.recommendationCursor = saved.recommendationCursor || {};

    $$('[data-home]').forEach(function (button) {
      var selected = button.dataset.home === state.home;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    $$('[data-category]').forEach(function (button) {
      var category = state.categories.filter(function (item) {
        return item.id === button.dataset.category;
      })[0];
      updateCategoryButton(button, category ? category.qty : 0);
    });

    var range = $('[data-budget-range]');
    if (range) range.value = state.budget;
    updateBudget();

    if (state.items.length) render();
    setStep(Math.max(1, Math.min(4, Number(saved.step) || 1)));

    restoringState = false;
    persistPlannerState();
    return true;
  }

  function selectedCount() {
    return state.categories.reduce(function (sum, item) {
      return sum + item.qty;
    }, 0);
  }

  function isValid() {
    if (state.step === 1 && !state.home) {
      alertMsg(t('chooseHome'));
      return false;
    }

    if (state.step === 2 && !selectedCount()) {
      alertMsg(t('chooseCategory'));
      return false;
    }

    return true;
  }

  function updateBudget() {
    var value = $('[data-budget-value]');
    var range = $('[data-budget-range]');
    clearAlert();

    if (value) value.textContent = money(state.budget);

    if (range) {
      var min = Number(range.min) || 1000;
      var max = Number(range.max) || 100000;
      var pct = ((state.budget - min) / (max - min)) * 100;
      range.style.setProperty('--range', Math.max(0, Math.min(100, pct)) + '%');
    }

    persistPlannerState();
  }

  function normalize(product) {
    var variants = (Array.isArray(product.variants) ? product.variants : []).filter(function (item) {
      return item && item.available;
    }).map(function (item) {
      return {
        id: item.id,
        title: item.title || '',
        option1: item.option1 || '',
        option2: item.option2 || '',
        option3: item.option3 || '',
        price: Number(item.price || 0)
      };
    }).sort(function (a, b) {
      return a.price - b.price;
    });
    var variant = variants[0];
    var images = Array.isArray(product.images) ? product.images : [];
    var image = images[0] && images[0].src ? images[0].src : '';

    if (!variant) return null;

    return {
      title: product.title,
      handle: product.handle,
      url: routeRoot() + 'products/' + product.handle,
      image: image,
      price: Number(variant.price || 0),
      variantId: variant.id,
      variantTitle: variant.title,
      variants: variants
    };
  }

  function isMattressProtector(product) {
    return /waterproof\s+mattress\s+protector|mattress\s+protector/i.test(product.title || '');
  }

  function fetchCollectionPage(handle, page) {
    return fetch(routeRoot() + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + page, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error(handle);
        return response.json();
      })
      .then(function (data) {
        return Array.isArray(data.products) ? data.products : [];
      });
  }

  function fetchCollection(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);

    var all = [];

    function load(page) {
      return fetchCollectionPage(handle, page).then(function (products) {
        all = all.concat(products);
        return products.length === 250 ? load(page + 1) : all;
      });
    }

    return load(1)
      .then(function (products) {
        var available = products
          .map(normalize)
          .filter(Boolean)
          .sort(function (a, b) {
            return a.price - b.price;
          });

        cache[handle] = available;
        return available;
      })
      .catch(function () {
        cache[handle] = [];
        return [];
      });
  }

  function categoryFromButton(button) {
    return {
      id: button.dataset.category,
      handle: button.dataset.handle,
      title: button.querySelector('[data-cat-title]') ? button.querySelector('[data-cat-title]').textContent.trim() : button.textContent.trim(),
      qty: Number(button.dataset.qty) || 0
    };
  }

  function syncCategories() {
    state.categories = $$('[data-category]').map(categoryFromButton).filter(function (item) {
      return item.qty > 0;
    });
  }

  function updateCategoryButton(button, qty) {
    qty = Math.max(0, Math.min(MAX_QTY, Number(qty) || 0));
    button.dataset.qty = String(qty);
    button.classList.toggle('is-selected', qty > 0);
    button.setAttribute('aria-pressed', qty > 0 ? 'true' : 'false');

    var qtyEl = button.querySelector('[data-cat-qty]');
    var minus = button.querySelector('[data-qty-minus]');
    if (qtyEl) qtyEl.textContent = qty;
    if (minus) minus.setAttribute('aria-disabled', qty <= 0 ? 'true' : 'false');

    syncCategories();
    clearAlert();
    persistPlannerState();
  }

  function setupCategoryButtons() {
    $$('[data-category]').forEach(function (button) {
      var title = isArabic && labels.ar.categoryTitles[button.dataset.category] ? labels.ar.categoryTitles[button.dataset.category] : button.textContent.trim();
      button.textContent = '';
      button.dataset.qty = '0';
      button.setAttribute('aria-pressed', 'false');
      button.innerHTML = [
        '<span class="mksp-cat-title" data-cat-title>' + esc(title) + '</span>',
        '<span class="mksp-qty" aria-label="Quantity">',
        '<span class="mksp-qty__btn" role="button" tabindex="0" data-qty-minus>-</span>',
        '<span class="mksp-qty__num" data-cat-qty>0</span>',
        '<span class="mksp-qty__btn" role="button" tabindex="0" data-qty-plus>+</span>',
        '</span>'
      ].join('');
    });
  }

  function detectMattressSizeFromTitle(title) {
    var text = String(title || '').toLowerCase();
    if (/180\s*[x*×]\s*200|king/.test(text)) return 'king';
    if (/120\s*(cm)?|100\s*(cm)?|single|twin/.test(text)) return 'single';
    return null;
  }

  function productMatchesMattressSize(product, size) {
    if (!size) return true;

    var text = String(product.title || '').toLowerCase();

    if (size === 'king') {
      return /180\s*[x*×]\s*200|180\s*cm|king/.test(text);
    }

    if (size === 'single') {
      return /120\s*[x*×]\s*200|100\s*[x*×]\s*200|120\s*cm|100\s*cm|single|twin/.test(text);
    }

    return true;
  }

  function variantText(product, variant) {
    return [
      product.title,
      variant && variant.title,
      variant && variant.option1,
      variant && variant.option2,
      variant && variant.option3
    ].join(' ').toLowerCase();
  }

  function textMatchesMattressSize(text, size) {
    if (!size) return true;

    if (size === 'king') {
      return /180\s*(x|\*)\s*200|180\s*cm|king/.test(text);
    }

    if (size === 'single') {
      return /120\s*(x|\*)\s*200|100\s*(x|\*)\s*200|120\s*cm|100\s*cm|single|twin/.test(text);
    }

    return true;
  }

  productMatchesMattressSize = function (product, size) {
    if (!size) return true;

    return product.variants.some(function (variant) {
      return textMatchesMattressSize(variantText(product, variant), size);
    }) || textMatchesMattressSize(String(product.title || '').toLowerCase(), size);
  };

  function productWithMattressVariant(product, size) {
    if (!size) return product;

    var match = product.variants.filter(function (variant) {
      return textMatchesMattressSize(variantText(product, variant), size);
    })[0];

    if (!match) return product;

    var sized = {};
    Object.keys(product).forEach(function (key) {
      sized[key] = product[key];
    });
    sized.price = match.price;
    sized.variantId = match.id;
    sized.variantTitle = match.title;
    return sized;
  }

  function expandGroups(groups) {
    var expanded = [];

    groups.forEach(function (group) {
      for (var i = 0; i < group.category.qty; i += 1) {
        expanded.push({
          key: group.category.id + '-' + i,
          category: group.category,
          products: group.products
        });
      }
    });

    return expanded;
  }

  function asPackageItem(product, group) {
    return {
      key: group.key,
      categoryId: group.category.id,
      category: group.category.title,
      handle: product.handle,
      url: product.url,
      image: product.image,
      price: product.price,
      title: product.title,
      variantId: product.variantId,
      locked: false
    };
  }

  function total(items) {
    return items.reduce(function (sum, item) {
      return sum + item.price;
    }, 0);
  }

  function cheapestPossible(groups) {
    return groups.reduce(function (sum, group) {
      return sum + group.products[0].price;
    }, 0);
  }

  function bestWithinShare(products, share, used) {
    var choice = products[0];

    products.forEach(function (product) {
      if (used[product.variantId]) return;
      if (product.price <= share && product.price >= choice.price) {
        choice = product;
      }
    });

    return choice;
  }

  function chooseBasePackage(groups) {
    var share = state.budget / groups.length;
    var used = {};
    var selected = groups.map(function (group) {
      var product = bestWithinShare(group.products, share, used);
      used[product.variantId] = true;
      return { group: group, product: product };
    });

    var selectedTotal = total(selected.map(function (entry) {
      return asPackageItem(entry.product, entry.group);
    }));

    if (selectedTotal > state.budget) {
      used = {};
      selected = groups.map(function (group) {
        var product = group.products.filter(function (item) {
          return !used[item.variantId];
        })[0] || group.products[0];
        used[product.variantId] = true;
        return { group: group, product: product };
      });
    }

    return selected;
  }

  function upgradePackage(groups, selected) {
    var upgraded = selected.slice();
    var guard = 0;

    while (guard < 100) {
      guard += 1;

      var currentItems = upgraded.map(function (entry) {
        return asPackageItem(entry.product, entry.group);
      });
      var remaining = state.budget - total(currentItems);
      var best = null;

      if (remaining <= 0) break;

      groups.forEach(function (group, groupIndex) {
        var current = upgraded[groupIndex].product;

        group.products.forEach(function (candidate) {
          var increase = candidate.price - current.price;
          var alreadyUsed = upgraded.some(function (entry, index) {
            return index !== groupIndex && entry.product.variantId === candidate.variantId;
          });

          if (alreadyUsed || increase <= 0 || increase > remaining) return;

          if (!best || increase > best.increase) {
            best = {
              groupIndex: groupIndex,
              product: candidate,
              increase: increase
            };
          }
        });
      });

      if (!best) break;

      upgraded[best.groupIndex] = {
        group: groups[best.groupIndex],
        product: best.product
      };
    }

    return upgraded.map(function (entry) {
      return asPackageItem(entry.product, entry.group);
    });
  }

  function inferMattressSize(items) {
    var size = null;

    items.forEach(function (item) {
      if (size) return;
      if (/bedroom|bed/i.test(item.categoryId)) {
        size = detectMattressSizeFromTitle(item.title);
      }
    });

    return size;
  }

  function applyMattressSize(groups, size) {
    return groups.map(function (group) {
      if (group.category.id !== 'mattresses') return group;

      var filtered = group.products.filter(function (product) {
        if (isMattressProtector(product)) return false;
        return productMatchesMattressSize(product, size);
      }).map(function (product) {
        return productWithMattressVariant(product, size);
      }).sort(function (a, b) {
        return a.price - b.price;
      });

      return {
        key: group.key,
        category: group.category,
        products: filtered.length ? filtered : group.products.filter(function (product) {
          return !isMattressProtector(product);
        })
      };
    });
  }

  function loadSelectedGroups() {
    return Promise.all(
      state.categories.map(function (category) {
        return fetchCollection(category.handle).then(function (products) {
          return {
            category: category,
            products: products
          };
        });
      })
    );
  }

  function buildPackage() {
    return loadSelectedGroups().then(function (groups) {
      var missing = groups.filter(function (group) {
        return !group.products.length;
      });

      if (missing.length) {
        return {
          ok: false,
          reason: 'products',
          minimum: 0,
          items: []
        };
      }

      var expanded = expandGroups(groups);
      var preliminary = chooseBasePackage(expanded);
      var preliminaryItems = preliminary.map(function (entry) {
        return asPackageItem(entry.product, entry.group);
      });
      var mattressSize = inferMattressSize(preliminaryItems);
      expanded = applyMattressSize(expanded, mattressSize);

      if (expanded.some(function (group) { return !group.products.length; })) {
        return {
          ok: false,
          reason: 'products',
          minimum: 0,
          items: []
        };
      }

      var minimum = cheapestPossible(expanded);

      if (state.budget < minimum) {
        return {
          ok: false,
          reason: 'budget',
          minimum: minimum,
          items: []
        };
      }

      var selected = chooseBasePackage(expanded);
      var items = upgradePackage(expanded, selected);

      return {
        ok: true,
        minimum: minimum,
        groups: expanded,
        items: items,
        mattressSize: mattressSize
      };
    });
  }

  function lockedText(item) {
    return item.locked ? t('locked') : t('lock');
  }

  function icon(name) {
    var icons = {
      lock: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 10V8a5 5 0 0 1 10 0v2"/><rect x="5" y="10" width="14" height="10" rx="2"/></svg>',
      change: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 7h-9a4 4 0 0 0-4 4v1"/><path d="m17 4 3 3-3 3"/><path d="M4 17h9a4 4 0 0 0 4-4v-1"/><path d="m7 20-3-3 3-3"/></svg>',
      remove: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M6 7l1 13h10l1-13"/><path d="M9 7V4h6v3"/></svg>'
    };
    return icons[name] || '';
  }

  function card(item, index) {
    return [
      '<article class="mksp-product' + (item.locked ? ' is-locked' : '') + '" data-result-index="' + index + '">',
      '<div class="mksp-product__media">',
      '<a class="mksp-product__image" href="' + esc(item.url) + '">' + (item.image ? '<img src="' + esc(item.image) + '" alt="' + esc(item.title) + '" loading="lazy">' : '') + '</a>',
      '<div class="mksp-card-actions">',
      '<button class="mksp-card-action mksp-card-action--lock" type="button" data-lock-item="' + index + '">' + icon('lock') + '<span>' + lockedText(item) + '</span></button>',
      '<button class="mksp-card-action mksp-card-action--change" type="button" data-change-item="' + index + '">' + icon('change') + '<span>' + t('change') + '</span></button>',
      '<button class="mksp-card-action mksp-card-action--remove" type="button" data-remove-item="' + index + '">' + icon('remove') + '<span>' + t('remove') + '</span></button>',
      '</div>',
      '</div>',
      '<div class="mksp-product__body">',
      '<span class="mksp-product__category">' + esc(item.category) + '</span>',
      '<h3 class="mksp-product__title">' + esc(item.title) + '</h3>',
      '<strong class="mksp-product__price">' + money(item.price) + '</strong>',
      '<a class="mksp-product__link" href="' + esc(item.url) + '">' + t('viewProduct') + '</a>',
      '</div></article>'
    ].join('');
  }

  function recommendedCard(item, index) {
    var packageTotal = total(state.items);
    var remaining = Math.max(state.budget - packageTotal, 0);
    var extra = Math.max(item.price - remaining, 0);
    var label = extra > 0 ? t('addFor') + money(extra) : t('addWithin');

    return [
      '<article class="mksp-product mksp-product--recommended' + (item.locked ? ' is-locked' : '') + '">',
      '<div class="mksp-product__media">',
      '<a class="mksp-product__image" href="' + esc(item.url) + '">' + (item.image ? '<img src="' + esc(item.image) + '" alt="' + esc(item.title) + '" loading="lazy">' : '') + '</a>',
      '<div class="mksp-card-actions">',
      '<button class="mksp-card-action mksp-card-action--lock" type="button" data-lock-recommended="' + index + '">' + icon('lock') + '<span>' + lockedText(item) + '</span></button>',
      '<button class="mksp-card-action mksp-card-action--change" type="button" data-change-recommended="' + index + '">' + icon('change') + '<span>' + t('change') + '</span></button>',
      '<button class="mksp-card-action mksp-card-action--remove" type="button" data-remove-recommended="' + index + '">' + icon('remove') + '<span>' + t('remove') + '</span></button>',
      '</div>',
      '</div>',
      '<div class="mksp-product__body">',
      '<span class="mksp-product__category">' + esc(item.category) + '</span>',
      '<h3 class="mksp-product__title">' + esc(item.title) + '</h3>',
      '<strong class="mksp-product__price">' + money(item.price) + '</strong>',
      '<button class="mksp-product__link mksp-product__link--button" type="button" data-add-recommended="' + esc(item.variantId) + '">' + esc(label) + '</button>',
      '</div></article>'
    ].join('');
  }

  function render() {
    var grid = $('[data-results-grid]');
    if (!grid) return;

    var packageTotal = total(state.items);
    var remaining = Math.max(state.budget - packageTotal, 0);
    var html = '';

    if (state.items.length) {
      html += '<div class="mksp-result-block"><div class="mksp-result-head"><h3>' + t('selectedPackage') + '</h3><button class="mksp-btn mksp-btn--secondary mksp-btn--small" type="button" data-save-package>' + t('savePackage') + '</button></div><div class="mksp-results-grid">' + state.items.map(card).join('') + '</div></div>';
    } else {
      html += '<div class="mksp-empty"><strong>' + t('noProducts') + '</strong><p>' + t('checkProducts') + '</p></div>';
    }

    if (remaining > 0 && state.items.length) {
      html += '<div class="mksp-empty mksp-empty--soft"><strong>' + t('closest') + '</strong><p>' + t('bestMatch') + '</p></div>';
    }

    if (state.recommended.length) {
      html += '<div class="mksp-result-block mksp-result-block--suggestions"><h3>' + t('recommended') + '</h3><p>' + t('recommendedDesc') + '</p><div class="mksp-results-grid">' + state.recommended.map(recommendedCard).join('') + '</div></div>';
    }

    grid.innerHTML = html;

    var count = $('[data-selected-count]');
    var totalEl = $('[data-package-total]');
    var remainingEl = $('[data-remaining-budget]');

    if (count) count.textContent = state.items.length + ' ' + (state.items.length === 1 ? t('product') : t('products'));
    if (totalEl) totalEl.textContent = money(packageTotal);
    if (remainingEl) remainingEl.textContent = money(remaining);
    persistPlannerState();
  }

  function loadRecommended() {
    var selectedIds = {};
    state.categories.forEach(function (category) {
      selectedIds[category.id] = true;
    });

    var pools = RECOMMENDED.filter(function (category) {
      return !selectedIds[category.id];
    });

    if (!pools.length) pools = RECOMMENDED.slice();

    var recommendations = Promise.all(
      pools.map(function (category) {
        return fetchCollection(category.handle).then(function (products) {
          return products.slice(0, 8).map(function (product) {
            var item = asPackageItem(product, {
              key: 'recommended-' + category.id,
              category: category
            });
            item.category = category.title;
            item.recommendationId = category.id;
            item.recommendationHandle = category.handle;
            item.locked = false;
            return item;
          });
        });
      })
    );

    var protector = selectedIds.mattresses ? fetchCollection('mattress').then(function (products) {
      var product = products.filter(isMattressProtector)[0];
      if (!product) return null;

      var item = asPackageItem(product, {
        key: 'recommended-mattress-protector',
        category: {
          id: 'mattress-protector',
          title: 'Mattress Protector'
        }
      });
      item.category = 'Mattress Protector';
      item.recommendationId = 'mattress-protector';
      item.recommendationHandle = 'mattress';
      item.locked = false;
      return item;
    }) : Promise.resolve(null);

    return Promise.all([recommendations, protector]).then(function (results) {
      var groups = results[0];
      var protectorItem = results[1];
      var used = {};
      state.items.forEach(function (item) {
        used[item.variantId] = true;
      });

      var normal = groups.map(function (group) {
        return group.filter(function (item) {
          return !used[item.variantId];
        })[0];
      }).filter(Boolean);

      state.recommended = [];

      if (protectorItem && !used[protectorItem.variantId]) {
        state.recommended.push(protectorItem);
      }

      normal.some(function (item) {
        if (state.recommended.length >= 2) return true;
        state.recommended.push(item);
        return false;
      });
    });
  }

  function generate() {
    setStep(4);
    $('[data-results-state]').hidden = true;
    $('[data-loading-state]').hidden = false;

    buildPackage().then(function (result) {
      if (!result.ok) {
        $('[data-loading-state]').hidden = true;
        $('[data-results-state]').hidden = true;
        setStep(3);

        if (result.reason === 'products') {
          alertMsg(t('collectionMissing'), true, true);
          return;
        }

        alertMsg(t('lowBudget') + money(result.minimum) + '.', true, true);
        return;
      }

      state.groups = result.groups;
      state.items = result.items;
      state.mattressSize = result.mattressSize;
      state.changeCursor = {};
      state.recommendationCursor = {};

      loadRecommended().then(function () {
        setTimeout(function () {
          render();
          $('[data-loading-state]').hidden = true;
          $('[data-results-state]').hidden = false;
        }, 520);
      });
    });
  }

  function findGroupForItem(item) {
    return state.groups.filter(function (group) {
      return group.key === item.key;
    })[0];
  }

  function changeItem(index) {
    var current = state.items[index];
    if (!current) return;

    if (current.locked) {
      alertMsg(t('lockedChange'));
      return;
    }

    var group = findGroupForItem(current);
    if (!group) return;

    var currentTotal = total(state.items);
    var budgetLimit = state.budget - currentTotal + current.price;
    var used = {};

    state.items.forEach(function (item, itemIndex) {
      if (itemIndex !== index) used[item.variantId] = true;
    });

    var alternatives = group.products.filter(function (product) {
      return product.variantId !== current.variantId && !used[product.variantId] && product.price <= budgetLimit;
    }).sort(function (a, b) {
      return a.price - b.price;
    });

    if (!alternatives.length) {
      alertMsg(t('noAlternative'));
      return;
    }

    var cursorKey = current.key || current.categoryId || String(index);
    var cursor = state.changeCursor[cursorKey] || 0;
    var next = alternatives[cursor % alternatives.length];
    state.changeCursor[cursorKey] = cursor + 1;

    state.items[index] = asPackageItem(next, group);
    render();
  }

  function toggleLock(index) {
    if (!state.items[index]) return;
    state.items[index].locked = !state.items[index].locked;
    render();
  }

  function removeItem(index) {
    var item = state.items[index];
    if (!item) return;

    if (item.locked) {
      alertMsg(t('lockedRemove'));
      return;
    }

    state.items.splice(index, 1);
    render();
  }

  function toggleRecommendedLock(index) {
    if (!state.recommended[index]) return;
    state.recommended[index].locked = !state.recommended[index].locked;
    render();
  }

  function removeRecommended(index) {
    var item = state.recommended[index];
    if (!item) return;

    if (item.locked) {
      alertMsg(t('recLockedRemove'));
      return;
    }

    state.recommended.splice(index, 1);
    render();
  }

  function changeRecommended(index) {
    var current = state.recommended[index];
    if (!current) return;

    if (current.locked) {
      alertMsg(t('recLockedChange'));
      return;
    }

    fetchCollection(current.recommendationHandle).then(function (products) {
      var used = {};
      state.items.forEach(function (item) {
        used[item.variantId] = true;
      });
      state.recommended.forEach(function (item, itemIndex) {
        if (itemIndex !== index) used[item.variantId] = true;
      });

      var next = products.filter(function (product) {
        return product.variantId !== current.variantId && !used[product.variantId];
      })[0];

      if (!next) {
        alertMsg(t('noRecAlternative'));
        return;
      }

      var replacement = asPackageItem(next, {
        key: 'recommended-' + current.recommendationId,
        category: {
          id: current.recommendationId,
          title: current.category
        }
      });
      replacement.category = current.category;
      replacement.recommendationId = current.recommendationId;
      replacement.recommendationHandle = current.recommendationHandle;
      replacement.locked = false;
      state.recommended[index] = replacement;
      render();
    });
  }

  changeRecommended = function (index) {
    var current = state.recommended[index];
    if (!current) return;

    if (current.locked) {
      alertMsg(t('recLockedChange'));
      return;
    }

    var selectedIds = {};
    state.categories.forEach(function (category) {
      selectedIds[category.id] = true;
    });

    var pools = RECOMMENDED.filter(function (category) {
      return !selectedIds[category.id];
    });

    return Promise.all(
      pools.map(function (category) {
        return fetchCollection(category.handle).then(function (products) {
          return products.slice(0, 12).map(function (product) {
            var item = asPackageItem(product, {
              key: 'recommended-' + category.id,
              category: category
            });
            item.category = category.title;
            item.recommendationId = category.id;
            item.recommendationHandle = category.handle;
            item.locked = false;
            return item;
          });
        });
      })
    ).then(function (groups) {
      var used = {};
      state.items.forEach(function (item) {
        used[item.variantId] = true;
      });
      state.recommended.forEach(function (item, itemIndex) {
        if (itemIndex !== index) used[item.variantId] = true;
      });

      var pool = groups.reduce(function (all, group) {
        return all.concat(group);
      }, []).filter(function (item) {
        return item.variantId !== current.variantId && !used[item.variantId];
      }).sort(function (a, b) {
        return a.price - b.price;
      });

      var cursorKey = current.recommendationId || current.recommendationHandle || String(index);
      var cursor = state.recommendationCursor[cursorKey] || 0;
      var next = pool[cursor % pool.length];

      if (!next) {
        alertMsg('No alternative recommendation is available right now.');
        return;
      }

      state.recommendationCursor[cursorKey] = cursor + 1;
      state.recommended[index] = next;
      render();
    });
  };

  function savePackage() {
    try {
      localStorage.setItem('mksp_saved_package', JSON.stringify({
        savedAt: new Date().toISOString(),
        budget: state.budget,
        items: state.items
      }));
      alertMsg(t('saved'));
    } catch (error) {
      alertMsg(t('saveFailed'));
    }
  }

  function addRecommended(variantId) {
    var product = state.recommended.filter(function (item) {
      return String(item.variantId) === String(variantId);
    })[0];

    if (!product) return;

    state.items.push(product);
    state.recommended = state.recommended.filter(function (item) {
      return String(item.variantId) !== String(variantId);
    });
    render();
  }

  function addToCart(button) {
    if (!state.items.length) {
      alertMsg(t('noCart'));
      return;
    }

    var original = button.textContent;
    button.textContent = t('adding');
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: Object.keys(state.items.reduce(function (map, item) {
          map[item.variantId] = (map[item.variantId] || 0) + 1;
          return map;
        }, {})).map(function (variantId) {
          return {
            id: variantId,
            quantity: state.items.filter(function (item) {
              return String(item.variantId) === String(variantId);
            }).length
          };
        })
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart');
        window.location.href = '/cart';
      })
      .catch(function () {
        alertMsg(t('cartFailed'));
      })
      .finally(function () {
        button.textContent = original;
        button.disabled = false;
      });
  }

  root.addEventListener('click', function (event) {
    var start = event.target.closest('[data-start-planner]');
    var home = event.target.closest('[data-home]');
    var category = event.target.closest('[data-category]');
    var plus = event.target.closest('[data-qty-plus]');
    var minus = event.target.closest('[data-qty-minus]');
    var next = event.target.closest('[data-next-step]');
    var prev = event.target.closest('[data-prev-step]');
    var make = event.target.closest('[data-generate-package]');
    var add = event.target.closest('[data-add-package]');
    var lock = event.target.closest('[data-lock-item]');
    var change = event.target.closest('[data-change-item]');
    var remove = event.target.closest('[data-remove-item]');
    var lockRecommended = event.target.closest('[data-lock-recommended]');
    var changeRecommendedButton = event.target.closest('[data-change-recommended]');
    var removeRecommendedButton = event.target.closest('[data-remove-recommended]');
    var save = event.target.closest('[data-save-package]');
    var recommended = event.target.closest('[data-add-recommended]');

    if (start) {
      $('#smart-planner-wizard').scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    if (home) {
      clearAlert();
      $$('[data-home]').forEach(function (item) {
        item.classList.remove('is-selected');
        item.setAttribute('aria-pressed', 'false');
      });
      home.classList.add('is-selected');
      home.setAttribute('aria-pressed', 'true');
      state.home = home.dataset.home;
      persistPlannerState();
      return;
    }

    if (plus || minus) {
      event.preventDefault();
      event.stopPropagation();
      var button = event.target.closest('[data-category]');
      var qty = Number(button.dataset.qty) || 0;
      updateCategoryButton(button, qty + (plus ? 1 : -1));
      return;
    }

    if (category) {
      if (event.target.closest('.mksp-qty')) return;
      updateCategoryButton(category, category.classList.contains('is-selected') ? 0 : 1);
      return;
    }

    if (next) {
      if (isValid()) setStep(Math.min(4, state.step + 1));
      return;
    }

    if (prev) {
      setStep(Math.max(1, state.step - 1));
      return;
    }

    if (make) {
      if (isValid()) generate();
      return;
    }

    if (lock) {
      toggleLock(Number(lock.dataset.lockItem));
      return;
    }

    if (change) {
      changeItem(Number(change.dataset.changeItem));
      return;
    }

    if (remove) {
      removeItem(Number(remove.dataset.removeItem));
      return;
    }

    if (lockRecommended) {
      toggleRecommendedLock(Number(lockRecommended.dataset.lockRecommended));
      return;
    }

    if (changeRecommendedButton) {
      changeRecommended(Number(changeRecommendedButton.dataset.changeRecommended));
      return;
    }

    if (removeRecommendedButton) {
      removeRecommended(Number(removeRecommendedButton.dataset.removeRecommended));
      return;
    }

    if (save) {
      savePackage();
      return;
    }

    if (recommended) {
      addRecommended(recommended.dataset.addRecommended);
      return;
    }

    if (add) addToCart(add);
  });

  root.addEventListener('keydown', function (event) {
    var control = event.target.closest('[data-qty-plus], [data-qty-minus]');
    if (!control || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    control.click();
  });

  setupCategoryButtons();

  var range = $('[data-budget-range]');
  if (range) {
    state.budget = Number(range.value) || 1000;
    range.addEventListener('input', function (event) {
      state.budget = Number(event.target.value) || 1000;
      updateBudget();
    });
    updateBudget();
  }

  if (!restorePlannerState()) {
    setStep(1);
  }
})();
